import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    return (_openBlock(), _createElementBlock("div", _normalizeProps(_guardReactiveProps(_ctx.content.config)), [
        _createVNode(_component_g_dynamic_html, {
            template: _ctx.content.data.content
        }, null, 8, ["template"])
    ], 16));
}
